export interface ConversationsState {
    isReady         : boolean;
    conversations   : any;
    error?          : any;
}

export const CONVERSATIONS_INIT_STATE: ConversationsState = {
    isReady         : false,
    conversations   : null,
    error           : null,
};
